import * as React from 'react';

import { Box, BoxStyle } from './Box';
import Header from './Header';

export interface PageProps {
  title: string;
  subtitle: string;
  children: any;
}

export const Page = (props: PageProps) => (
  <div className={BoxStyle.Padded}>
    <Header title={props.title} subtitle={props.subtitle} />
    {props.children}
  </div>
);

export default Page;
